import { collection, doc, getDoc, getDocs, query, setDoc, where } from 'firebase/firestore';
import { db } from '../firebase';

export const VALIDADE_MESES = {
  'NR-35 — Trabalho em altura': 24,
  'NR-6 — Uso correto de EPIs': 24,
  'NR-6 — Uso de EPIs': 24,
  'Primeiros socorros industrial': 24,
  'NR-9 — Riscos ambientais': 24,
  'Padrão SIS — graus de limpeza': 24,
  'POP pintura industrial': 12,
  'POP jateamento abrasivo': 12,
  'POP Jateamento abrasivo': 12,
  'Hidrojateamento — técnicas': 12,
  'Alpinismo industrial': 24,
  'Política de SSO Jatear': 12,
  'Política de SSO': 12,
  'Código de conduta e ética': 24,
  'Gestão de resíduos industriais': 24,
  'Impacto ambiental — abrasivos': 24,
  'Liderança e comunicação': 0,
  'Gestão de equipes em campo': 0,
  'Controle de qualidade': 0,
  'Direitos e deveres': 0,
  'Integração Jatear': 0,
  'Integração Jatear — onboarding': 0,
  'Missão, visão e valores': 0,
  'História e clientes da Jatear': 0,
};

/**
 * Busca a validade em meses de um curso no Firestore.
 * Se o campo 'validadeMeses' estiver definido no documento do curso, retorna esse valor.
 * Caso contrário, cai no fallback estático VALIDADE_MESES.
 *
 * @param {string} nomeCurso - Nome exato do curso (campo 'nome' no Firestore)
 * @param {import('firebase/firestore').Firestore} [dbInstance] - Instância do Firestore (opcional; usa a instância padrão do módulo)
 * @returns {Promise<number|undefined>} Validade em meses, ou undefined se o curso não for encontrado em nenhuma fonte
 */
export async function buscarValidadeMeses(nomeCurso, dbInstance) {
  const firestore = dbInstance || db;
  try {
    const snap = await getDocs(
      query(collection(firestore, 'cursos'), where('nome', '==', nomeCurso))
    );
    if (!snap.empty) {
      const dados = snap.docs[0].data();
      if (dados.validadeMeses !== undefined && dados.validadeMeses !== null) {
        return dados.validadeMeses;
      }
    }
  } catch (e) {
    console.warn('buscarValidadeMeses: erro ao consultar Firestore, usando fallback.', e);
  }
  return VALIDADE_MESES[nomeCurso];
}

function addMeses(dataStr, meses) {
  const d = new Date(dataStr);
  d.setMonth(d.getMonth() + meses);
  return d.toISOString();
}

export async function verificarEAtualizarValidade(uid) {
  try {
    const snap = await getDoc(doc(db, 'progresso', uid));
    if (!snap.exists()) return;

    const dados = snap.data();
    const treinamentos = { ...(dados.treinamentos || {}) };
    const hoje = new Date();
    let alterou = false;

    Object.entries(treinamentos).forEach(([nome, info]) => {
      if (info.status !== 'concluido') return;

      // TODO: usar buscarValidadeMeses quando possível para ler validadeMeses do Firestore
      const meses = VALIDADE_MESES[nome];
      if (meses === undefined || meses === 0) return;

      if (!info.venceEm && info.concluidoEm) {
        treinamentos[nome] = { ...info, venceEm: addMeses(info.concluidoEm, meses) };
        alterou = true;
      }

      const venceEm = treinamentos[nome].venceEm;
      if (venceEm && new Date(venceEm) < hoje) {
        treinamentos[nome] = { ...treinamentos[nome], status: 'vencido' };
        alterou = true;
      }
    });

    if (alterou) {
      await setDoc(doc(db, 'progresso', uid), { treinamentos }, { merge: true });
    }

    return treinamentos;
  } catch (e) {
    console.error('verificarValidade:', e);
  }
}

export function diasParaVencer(venceEmStr) {
  if (!venceEmStr) return null;
  const diff = new Date(venceEmStr) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}
